import { updateCart } from './update-cart'

const $doc = $(document)

$doc.on('click', '.js-qty span', function () {
  const $this = $(this)
  const $parent = $this.parent()
  const $cartCounter = $('.js-cart-count')
  const qtyInput = $parent.find('input')
  let qtyInputVal = qtyInput.val()
  qtyInputVal = ($.isNumeric(qtyInputVal)) ? qtyInputVal : 0
  const $form = $this.closest('form')

  if ($this.hasClass('qty__btn--plus')) {
    qtyInputVal++
    qtyInputVal = (qtyInputVal < 0) ? 1 : qtyInputVal

    $cartCounter.text(parseInt($cartCounter.text()) + 1)
  } else {
    qtyInputVal--
    qtyInputVal = (qtyInputVal < 0) ? 0 : qtyInputVal
    $cartCounter.text(parseInt($cartCounter.text()) - 1)
  }
  qtyInput.val(qtyInputVal)

  if ($this.closest('.js-cart-container').length && !$this.closest('.js-form-product').length) {
    $parent.addClass('qty--prevent')

    updateCart($form, true, undefined)
  }
})
